import DefaultPage from './DefaultPage';
import Crud from './Crud';
import Instances from './Instances';
import AlertList from './AlertList';
import { getDisplayKeys } from '../../common/ambient'
import {
  TIME_ALERT_PARAM,
  ALERT_FREQS,
  getAlertFreqArr,
  PREVENTATIVE_MAINTENANCE_ALERT_TEMPLATE,
  REPLACE_BATTERIES_ALERT_TEMPLATE
} from './alertConstants';

export {
  DefaultPage,
  Crud,
  Instances,
  AlertList,
};
export { default as GroupAlerts } from './GroupAlerts';
export { default as AlertSets } from './AlertSets';
export { default as AlertForm } from './AlertForm';
export { default as CreateAlertSet } from './CreateAlertSet';
export { default as AlertSet } from './AlertSet';
export { default as AlertDescription } from './AlertDescription';

// Re-export from alertConstants for backward compatibility
export {
  TIME_ALERT_PARAM,
  ALERT_FREQS,
  getAlertFreqArr,
  PREVENTATIVE_MAINTENANCE_ALERT_TEMPLATE,
  REPLACE_BATTERIES_ALERT_TEMPLATE
};

export const getAlertParamsForDevice = (currentDevice) => {
  if (!currentDevice || !currentDevice.lastData) return []
  const theKeys = getDisplayKeys([currentDevice.lastData])
    .filter(k => k !== 'dateutc')
  theKeys.push('notReporting');
  theKeys.push(TIME_ALERT_PARAM);
  return theKeys
}

export const alertSetOk = (aset) => {
  return aset.title && aset.description && aset.deviceIds && aset.deviceIds.length > 0 && aset.alerts && aset.alerts.length > 0
}

export const alertSetsAvail = user => {
  return true
}
export { default as AlertSetMemberCard } from './AlertSetMemberCard';

// Parameter helper functions (battery and leak)
export {
  isBatteryParam,
  isLowBatteryFlipped,
  isBatteryLow,
  getBatteryDisplayValue,
  getBatteryAlertConfig,
  isLeakParam,
  getLeakDisplayValue,
  getLeakAlertConfig
} from './paramHelpers';
